module.exports = __webpack_public_path__ + "static/media/S4N10-4.1d944859.svg";